var map = {
	"./chevron-down.svg": 6487,
	"./close.svg": 6447,
	"./delete.svg": 2428,
	"./email.svg": 9063,
	"./emoji-disappointed.svg": 5674,
	"./emoji-doh.svg": 5391,
	"./emoji-face.svg": 9585,
	"./emoji-flushed.svg": 8055,
	"./emoji-unamused.svg": 1122,
	"./heart.svg": 1039,
	"./information.svg": 2673,
	"./open-in-new-window.svg": 8136,
	"./save-for-later.svg": 5337,
	"./sign-in-to-save.svg": 5654,
	"./star.svg": 2193,
	"./tick.svg": 3834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6692;